import { Injectable, inject } from '@angular/core';
import { Job, JobsStore } from '@dges/modules/portfolio/domain';
import { Actions, ofType } from '@ngrx/effects';

import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import * as JobsActions from './jobs.actions';
import * as JobsSelectors from './jobs.selectors';

@Injectable()
export class JobsFacade implements JobsStore {
  private store = inject(Store);
  private actions$ = inject(Actions);

  loaded$ = this.store.pipe(select(JobsSelectors.getJobsLoaded));
  allItems$ = this.store.pipe(select(JobsSelectors.getAllJobs));
  selectedItem$ = this.store.pipe(select(JobsSelectors.getSelected));

  load(): Observable<Job[]> {
    this.store.dispatch(JobsActions.loadJobs());
    return this.allItems$;
  }

  addItem(job: Job) {
    this.store.dispatch(JobsActions.addJob({ job }));
  }

  editItem(job: Job) {
    this.store.dispatch(JobsActions.editJob({ job }));
  }

  deleteItem(job: Job) {
    this.store.dispatch(JobsActions.deleteJob({ job }));
  }

  editOrAddSuccess(): Observable<Actions> {
    return this.actions$.pipe(
      ofType(JobsActions.addJobSuccess, JobsActions.editJobSuccess),
    );
  }
}
